import Aura from '@primeuix/themes/aura'
import 'primeicons/primeicons.css'
import 'element-plus/dist/index.css'
import './assets/css/satoshi.css'
import './assets/css/style.css'
import 'flatpickr/dist/flatpickr.min.css'

import VueApexCharts from 'vue3-apexcharts'
import PrimeVue from 'primevue/config'
import App from '@/App.vue'
import { createApp } from 'vue'
import { registerPlugins } from '@/plugins'
import ElementPlus from 'element-plus'

import ptBR from './locales/pt-BR.json'

const app = createApp(App)

app.use(ElementPlus)
app.use(VueApexCharts)
app.use(PrimeVue, {
  theme: {
    preset: Aura,
    options: {
      darkModeSelector: false,
    },
  },
  locale: ptBR.globals.primevue,
})

registerPlugins(app)

app.mount('#app')
